<template>
  <div
    class="orm-datepicker"
    :class="{ 'datepicker__mapModule orm-row': viewType == 'mapModule' }"
  >
    <div
      :class="{
        'orm-datecol orm-pr-sm-8': viewType !== 'mapModule',
        'orm-datecol--map orm-col-xs-12': viewType == 'mapModule',
      }"
    >
      <Datepicker
        :start-only="true"
        :infobar="false"
        :readonly="false"
        viewType="mapModule"
      />
    </div>
    <div
      :class="{
        'orm-datecol orm-pl-sm-8': viewType !== 'mapModule',
        'orm-datecol--map orm-col-xs-12': viewType == 'mapModule',
      }"
    >
      <FormSelect
        :data="abolength"
        :selected="selectedAbo"
        myOptionsText="key"
        optionlabel=" Monate"
        optionkey="key"
        icon="fal fa-clock"
        :title="i18n('search/label/minabo_title') || 'Laufzeit'"
        @selected="selectAbo"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import i18n from "@/mixins/mixins";

import Datepicker from "@/components/ui/datepicker-startonly.vue"; // @ is an alias to /src
// import SimpleSelect from "@/components/ui/INPUTS/SimpleSelect.vue"; // @ is an alias to /src
import FormSelect from "@/components/ui/INPUTS/FormSelectHeader.vue"; // @ is an alias to /src

export default defineComponent({
  name: "datepicker_abo",
  components: { Datepicker, FormSelect },
  mixins: [i18n],
  setup() {
    let stations = store.getters["stations/GET_STATIONS"];
    const filtered = store.getters["stations/GET_STATIONS_FILTERED"];
    const type = store.getters["userSession/GET_STATIONTYPE"];
    const abolength = store.getters["reservation/GET_ABO_LENGTH"];

    if (type) {
      stations = filtered[type];
    }

    return {
      stations,
      store,
      abolength,
    };
  },
  data() {
    return {
      stationSelected: store.getters["userSession/GET_STATION"],
      stationSelectedEnd: store.getters["userSession/GET_STATION_END"],
      selectedAbo: store.getters["reservation/GET_SELECTEDABO"],
    };
  },
  created() {
    if (this.carAboLengthOptions) {
      const monthDays = store.getters["ORMgeneral/GET_PARAMETER"](
        "SORM_DATE_END_VALUE"
      );
      this.abolength = this.carAboLengthOptions.map((num) => ({
        key: num.toString(),
        value: monthDays * num,
      }));
    }
  },
  mounted() {
    store.watch(
      () => store.getters["stations/GET_OPENINGTIMES"],
      () => {
        this.selectedAbo = store.getters["reservation/GET_SELECTEDABO"];
      }
    );
  },
  props: {
    data: Object,
    type: String,
    step: Number,
    carAboLengthOptions: Array,
    viewType: {
      type: String,
      default: "searchbar",
    },
  },
  methods: {
    async selectAbo(abo) {
      if (!this.isLoading) {
        await store.dispatch("reservation/SET_ABOLENGTH", abo);
        await store.dispatch("stations/SET_OPENINGTIMES");
        // this.isLoading = true;
        this.selectedAbo = abo;
        // this.loadCarGroup();
      }
    },
  },
});
</script>
